import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import Footer from "./Footer";
import axios from "axios";

export const ThankYou = () => {
    const { apipath, logout } = useAuth();
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('userData'));
    const token = localStorage.getItem('token');
    const [time, setTime] = useState(5);
    if(!userData){
        logout();
    }
    useEffect(() => {
        // Get the current URL
        const currentUrl = window.location.href;

        // Replace the current history entry with the current URL
        window.history.replaceState(null, "", currentUrl);
    });

    const logoutuser = async () => {
        const response = await axios.post(apipath+'/logout', {},
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        );
        logout();
    }

    setInterval(() => {
        if(time > 0){
            setTime(time - 1);
        }
        else{
            const currentUrl = window.location.href;
    
            // Replace the current history entry with the current URL
            window.history.replaceState(null, "", currentUrl);
            logoutuser();
        }
    }, 1000);

    return (
        <>

            {<Navbar page={"login"} />}
            <div className="min-h-screen flex items-center justify-center bg-cyan-700">
                <div className="w-full max-w-md bg-white p-8 shadow-lg rounded-lg">
                    <h2 className="text-2xl font-bold text-center mb-6">Test Submitted</h2>
                    <div className="flex-col justify-center text-center">
                        <h2 className="font-semibold">Hello {userData.name},</h2>
                        <h3 className="font-semibold">Your Test has been submitted successfully.</h3>
                        <h3 className="font-semibold">Thank You.</h3>
                    </div>

                    {/* <p className="mt-6 text-center text-sm text-gray-600">
                        Don't have an account?{' '}
                        <a href="#" className="text-indigo-600 hover:underline">
                            Sign up
                        </a>
                    </p> */}
                </div>
            </div>
            {<Footer />}
        </>
    )
};